import { Injectable } from '@angular/core';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class MotivoCancelamentoService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'motivoCancelamento';
  }

  protected getBaseUrlPublic(): string {
    throw new Error("Método não suportado!");
  }

}
